export default {
  path: 'aggregator/solutions/:id',
  name: 'Aggregator_solutions_details',
  meta: {
    parent_vue_name: 'Aggregator_solutions',
    breadcrumb_value: 'road-maintenance.solutions',
    open_tab: 'solution',
    redirectViewName: 'Aggregator_solutions'
  },
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../../common/views/AggregatorDetails.vue')
}
